import { useMutation } from '@tanstack/react-query';

import { Entity } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { patchDocument } from '../../requests/patchDocument';
import { DocumentParams } from '../../types/DocumentParams';

export const useApplyDocumentPatch = () => {
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync: applyDocumentPatch, isPending } = useMutation({
    mutationFn: ({
      id,
      documentParams,
      data,
    }: {
      id: string;
      documentParams: DocumentParams;
      data: Entity;
    }) => patchDocument(constructPatch, id, documentParams, data),
  });

  return { applyDocumentPatch, isPending };
};
